"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toTwoDigitsNumber = function (item) {
    return item <= 9 ? "0" + item : String(item);
};
function convertMMSSToSS(duration) {
    if (!duration) {
        return 0;
    }
    return duration
        .split(':')
        .reverse()
        .reduce(function (acc, chunk, i) {
        return acc + Number(chunk) * Math.pow(60, i);
    }, 0);
}
exports.convertMMSSToSS = convertMMSSToSS;
function convertISO8601ToMMSS(durationStr) {
    if (!durationStr) {
        return '00:00';
    }
    var _a = durationStr.match(/^P(?:(\d+)D)?T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/), parts = _a.slice(1);
    var numParts = parts.map(function (part) { return Number(part) || 0; });
    var numDays = numParts[0], numHours = numParts[1], numMinutes = numParts[2], numSeconds = numParts[3];
    var _b = [
        numDays * 24 + numHours,
        numMinutes,
        numSeconds,
    ].map(exports.toTwoDigitsNumber), hours = _b[0], minutes = _b[1], seconds = _b[2];
    if (hours === '00') {
        return minutes + ":" + seconds;
    }
    return hours + ":" + minutes + ":" + seconds;
}
exports.convertISO8601ToMMSS = convertISO8601ToMMSS;
exports.convertISO8601ToSS = function (durationStr) {
    return durationStr ? convertMMSSToSS(convertISO8601ToMMSS(durationStr)) : 0;
};
function convertSSToMMSS(durationSec) {
    durationSec = Math.floor(durationSec || 0);
    var chunks = [];
    do {
        chunks.unshift(exports.toTwoDigitsNumber(durationSec % 60));
        durationSec = Math.floor(durationSec / 60);
    } while (durationSec > 0);
    if (chunks.length < 2) {
        chunks.unshift('00');
    }
    return chunks.join(':');
}
exports.convertSSToMMSS = convertSSToMMSS;
//# sourceMappingURL=time.js.map